<template>
<div>
  <el-form style="margin-right: 80px" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="120px" class="demo-ruleForm">
    <el-form-item label="老人" prop="pid">
      <el-select v-fixZoom v-model="addEditForm.pid" filterable placeholder="请选择" :clearable="true" style="width:100%;">
        <el-option v-for="item in elderly" :key="item.index" :label="item.name" :value="item.id">
          <span>{{ getSelectElderlyShow(item) }}</span>
        </el-option>
      </el-select>
    </el-form-item>
  </el-form>
  <div style="height: 40px;margin-left: 40px">
    <el-row>
      <el-col :span="8">
        <img src="static/health/health_xueya.png">
        <span>高压：</span><strong style="font-size: 20px;color: #ff5900">{{healthVal1}}</strong>
      </el-col>
      <el-col :span="8">
        <img src="static/health/health_xueya.png">
        <span>低压：</span><strong style="font-size: 20px;color: #c7b25e">{{healthVal2}}</strong>
      </el-col>
      <el-col :span="8">
        <img src="static/health/health_xinlv.png">
        <span>心率：</span><strong style="font-size: 20px;color: #67b055">{{healthVal3}}</strong>
      </el-col>
    </el-row>
  </div>
  <el-row style="margin: 0 20px">
    <el-col :span="12">
      <div class="cancel-btn" @click="closeOpen()">
        <span>取消</span>
      </div>
    </el-col>
    <el-col :span="12">
      <div class="send-btn" @click="submitAddEdit('addEditForm')">
        <span>确定</span>
      </div>
    </el-col>
  </el-row>
  <div style="height: 20px"></div>
</div>
</template>

<script>
import {queryhealthdatamultiadd} from '../../../api/yanglaoyuan'
export default {
  name: 'bloodPressureSelect',
  model: {
    prop: 'bloodShow',
    event: 'change'
  },
  props: {
    addHealthObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      healthdatatype: [],
      elderly: [],
      addEditForm: {
        id: 0,
        pid: '',
        epid: '',
        health_data: []
      },
      addEditRules: {
        pid: [
          {required: true, message: '请选择老人', trigger: 'change'}
        ]
      },
      healthVal1: '',
      healthVal2: '',
      healthVal3: ''
    }
  },
  created () {
    this.healthdatatype = this.addHealthObj.healthdatatype
    this.elderly = this.addHealthObj.elderly
    let arr = this.addHealthObj.mqttObj.data ? this.addHealthObj.mqttObj.data.split('|') : []
    if (arr.length > 0) {
      this.healthVal1 = arr[0]
      this.healthVal2 = arr[1]
      this.healthVal3 = arr[2]
    }
    console.log(this.healthdatatype)
  },
  methods: {
    getSelectElderlyShow (item) {
      let elderlyName = item.name && item.name !== '' ? item.name : '--'
      let buildName = item.build_name && item.build_name !== '' ? item.build_name : '--'
      let floorName = item.floor_name && item.floor_name !== '' ? item.floor_name : '--'
      let roomName = item.room && item.room !== '' ? item.room + '号间' : '--'
      let bedName = item.bed_name && item.bed_name !== '' ? item.bed_name + '号床' : '--'
      return elderlyName + ' / ' + buildName + '--' + floorName + '--' + roomName + '--' + bedName
    },
    closeOpen () {
      this.$emit('change', false)
    },
    submitAddEdit (formName) {
      this.$refs[formName].validate((valid) => {
        let arr = []
        for (let i = 0; i < this.healthdatatype.length; i++) {
          if (this.healthdatatype[i].key_name === '血压-高压') {
            let obj = { id: this.healthdatatype[i].id, value: this.healthVal1 }
            arr.push(obj)
          }
          if (this.healthdatatype[i].key_name === '血压-低压') {
            let obj = { id: this.healthdatatype[i].id, value: this.healthVal2 }
            arr.push(obj)
          }
          if (this.healthdatatype[i].key_name === '心率') {
            let obj = { id: this.healthdatatype[i].id, value: this.healthVal3 }
            arr.push(obj)
          }
        }
        console.log(arr)
        if (valid) {
          let data = {
            id: 0,
            health_data: arr,
            pid: this.addEditForm.pid,
            epid: this.addEditForm.pid
          }
          queryhealthdatamultiadd(data).then(res => {
            this.$notify({title: '成功', message: '成功新增健康数据', type: 'success'})
            this.$emit('updateTable')
            this.$emit('change', false)
          }).catch(() => {})
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/bloodPressureSelect.vue